export default {
  unknown: 'An unexpected error has occurred',
  errorOccured: 'An error occurred',
  recordNotChanged: 'Record could not be changed',
  error: 'Error',
  errorUploadingFiles: 'Error uploading files',
  notUploadedFile: 'File could not uploaded',
  transferError: 'Error. Record has not been transfered',
  recordCountError: "You cant't download record as excel more than {0}. Please contact with Vektor",
  unknownError: 'Unknown Error',
  errorOccuredDuringUpdate: 'An error has occurred during update.',
  negativeOrEmptyError: 'The value cannot be negative or empty.',
  excelUploadErrors: 'Excel Upload Errors',
  totalRowsWithErrors: 'Total {count} rows with errors found.',
  pleaseFixErrorsAndReupload: 'Please fix the errors below and upload again.',
  errorRow: 'Error Row (Error Count)',
  errorColumnNumber: 'Error Column No',
  errorMessage: 'Error Message',
  generalRow: 'General Row',
  rowNumber: 'Row {number}',
  close: 'Close',
  errorDescriptionNotFound: 'Error description not found',
  endDateMustBeAfterStartDate: 'End date must be after start date',
};
